import React, { useState, useEffect } from "react";
import { Modal, Button, Dropdown } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";
import DocumentEditor from "./DocumentEditor";
import ClipLoader from "react-spinners/ClipLoader";
import { exportDocument } from "./documentHelpers";
import localization from "services/localization";

export default function DocumentModal({
  msg,
  loading,
  onUpdate,
  showModal,
  setShowModal,
  draftContent,
  displayContent,
  urlMapping,
}) {
  const [editDraftContent, setEditDraftContent] = useState(displayContent);
  const documentTitle = "AI Document";

  useEffect(() => {
    setEditDraftContent(displayContent);
  }, [displayContent]);

  const handleDownload = (type) => {
    exportDocument(editDraftContent, documentTitle, type);
  };

  const normalizeImageStyles = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");

    doc.querySelectorAll("img").forEach((img) => {
      const containerStyle = img.getAttribute("containerstyle");

      if (containerStyle) {
        img.style.cssText += ";" + containerStyle;
        img.removeAttribute("containerstyle");
      }
    });

    return doc.body.innerHTML;
  };

  const revertSignedUrls = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;

    const reverseMap = Object.fromEntries(
      Object.entries(urlMapping).map(([original, signed]) => [
        signed,
        original,
      ]),
    );

    div.querySelectorAll("img").forEach((img) => {
      const src = img.getAttribute("src");

      if (reverseMap[src]) {
        img.setAttribute("src", reverseMap[src]);
      }
    });

    return div.innerHTML;
  };

  const handleSave = async () => {
    let html = normalizeImageStyles(editDraftContent);
    html = revertSignedUrls(html);
    console.log(html);
    await onUpdate?.(html);
    setShowModal(false);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      size="xl"
      centered
      className="addEditModal themed-modal"
    >
      <Modal.Header className="bg-muted/20 border-border flex items-center justify-between">
        <Modal.Title className="text-xl font-semibold text-foreground">
          {localization.edit_document || "Edit Document"}
        </Modal.Title>

        <div className="flex items-center gap-2">
          <Button
            size="sm"
            className="action-btn-outline primary"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? (
              <ClipLoader size={16} color="var(--primary-icon)" />
            ) : (
              localization.save || "Save"
            )}
          </Button>

          <Dropdown align="end">
            <Dropdown.Toggle
              size="sm"
              className="action-btn-outline primary flex items-center gap-2"
            >
              <FiDownload />
              {localization.export || "Export"}
            </Dropdown.Toggle>

            <Dropdown.Menu className="bg-card border border-border shadow-lg rounded-lg">
              <Dropdown.Item onClick={() => handleDownload("pdf")}>
                {localization.export_as_pdf || "Export as PDF"}
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleDownload("docx")}>
                {localization.export_as_docx || "Export as DOCX"}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* Close button */}
          <button
            type="button"
            className="btn-close ml-2"
            aria-label="Close"
            onClick={() => setShowModal(false)}
          />
        </div>
      </Modal.Header>

      {/* BODY EDITOR */}
      <Modal.Body>
        <DocumentEditor
          initialContent={editDraftContent}
          documentTitle={documentTitle}
          onSave={(value) => setEditDraftContent(value)}
        />
      </Modal.Body>
    </Modal>
  );
}
